// Nutzerwechsel im selben Tab (Abmelden, Anmelden, Sitzung abgelaufen und anderer Nutzer meldet sich an):
// Zwischenspeicher auf Modulebene melden sich hier an und werden vor dem nächsten Zeichnen geleert.
const leeren = new Set<() => void>();

/** Aufräumfunktion für den Nutzerwechsel anmelden (einmal auf Modulebene aufrufen). */
export function beimNutzerwechsel(fn: () => void): void {
  leeren.add(fn);
}

/** Alle angemeldeten Zwischenspeicher leeren (ruft AuthContext synchron vor dem Setzen des neuen Nutzers). */
export function nutzerGewechselt(): void {
  leeren.forEach((fn) => {
    try {
      fn();
    } catch {
      /* ein Speicher darf das Leeren der anderen nicht verhindern */
    }
  });
}
